import { Injectable } from '@angular/core';
import { BrowserDataCacheAngularService } from '@flowstudio/browser-data-cache';

const FLOW_STUDIO_CACHE_CHANNEL = 'flowstudio-browser-data-cache';
const FLOW_STUDIO_CACHE_RESOURCE = 'flowstudio-cache';

@Injectable({
  providedIn: 'root',
})
export class BrowserCacheCoordinationService extends BrowserDataCacheAngularService {
  constructor() {
    super();
    this.configure({
      channelName: FLOW_STUDIO_CACHE_CHANNEL,
      resourceId: FLOW_STUDIO_CACHE_RESOURCE,
    });
  }
}
